/**
 * Panel management for CDP SDK.
 */

import { CDPSession, getSession } from '../session';

export class PanelManager {
  constructor(private readonly session: CDPSession = getSession()) {}

  async updatePanel(data: Record<string, any>): Promise<Record<string, any>> {
    return this.session.post('/api/cdp/cdp_panel/update', { data: { context: {}, data } });
  }

  async exportPanel(params?: Record<string, any>): Promise<Blob> {
    return this.session.request('GET', '/api/cdp/cdp_panel/extend/export', {
      params,
      responseType: 'blob',
    });
  }
}
